export type IntlResponse = {
  intl: string
  params: Record<string, string | number | unknown>
}

export const isIntlResponse = (value: unknown): value is IntlResponse => {
  return !!(value as IntlResponse).intl
}
